import { IBackgroundTask } from 'apps/idl/src/model/backgroundTask';
import { IAppInfo } from '../../../../../apps/idl/src/model/application/IAppInfo';
import { IDatabaseConfig } from '../../../../../apps/idl/src/model/store/IDatabaseConfig';
import { EntityBuilder } from '../../../../../apps/idl/src/services/security/EntityBuilder';
import { ISecurityConfig } from '../../../../../apps/idl/src/services/security/security/ISecurityConfig';
import { IEnvironment } from '../environment/IEnvironment';
import { EZoneGeo } from '../EZoneGeo';
import { IAuthentication } from '../IAuthentication';
import { IUpdateConfig } from '../update/IUpdateConfig';
import { ILoggerConfig } from './ILoggerConfig';

export abstract class ConfigData {

	/** Informations statique sur l'application. */
	public static appInfo: IAppInfo;
	/** Informations statique sur le type d'authentification qui va être utilisé par l'application. */
	public static authentication: IAuthentication;
	/** Informations sur l'environnement. */
	public static environment: IEnvironment;
	/** Informations sur les tâches de fond. */
	public static backgroundTask: IBackgroundTask;
	/** Configuration pour la mise à jour de l'application. */
	public static update: IUpdateConfig;
	/** Générateurs d'entités. */
	public static entityBuilders: EntityBuilder[];
	/** Indique si on est en version de production ou non. */
	public static isProductionEnvironment: boolean;
	/** Configuration des bases de données. */
	public static databases: IDatabaseConfig[] = [];
	/** Configuration des bases de données de workspace. */
	public static workspaceDatabases: IDatabaseConfig[];
	/** Configuration de la sécurité de l'application. */
	public static security?: ISecurityConfig;
	/** Configuration du logging. */
	public static logger: ILoggerConfig;
	/** Zone géographique de l'utilisateur */
	public static geoZoneApp?: number = EZoneGeo.METROPOLE;

	public static sceInitialize : boolean =  false;

	public static lecteurConnected: boolean = false;


}